import type { IconSvgObject } from './types';

const AlignHorizontalJustifyCenterIcon: IconSvgObject = [
  ["path", { d: "M8 16L8 8C8 6.89543 7.10457 6 6 6H5C3.89543 6 3 6.89543 3 8L3 16C3 17.1046 3.89543 18 5 18H6C7.10457 18 8 17.1046 8 16Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 14L21 10C21 8.89543 20.1046 8 19 8H18C16.8954 8 16 8.89543 16 10L16 14C16 15.1046 16.8954 16 18 16H19C20.1046 16 21 15.1046 21 14Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 21V3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default AlignHorizontalJustifyCenterIcon;
